import React, { memo } from 'react';
import { withNativeProps } from '../../utils/native-props';
export var PlaceholderIcon = /*#__PURE__*/memo(function (props) {
  return withNativeProps(props, /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79249 3.1698H13.5849V11.4906L10.4151 12.0495V5.43395H9.96227V12.1294L6.79249 12.6883V3.1698ZM10.4151 12.5094L13.5849 11.9504V20.8302H6.79249V13.1481L9.96227 12.5892V18.566H10.4151V12.5094ZM14.0377 11.8706V20.8302H20.8302V10.6729L17.6604 11.2318V18.566H17.2076V11.3117L14.0377 11.8706ZM17.6604 10.772V5.43395H17.2076V10.8518L14.0377 11.4108V3.1698H20.8302V10.2131L17.6604 10.772ZM6.33966 3.1698H3.1698V13.3271L6.33966 12.7681V3.1698ZM3.1698 20.8302V13.7869L6.33966 13.228V20.8302H3.1698Z"
  })));
});